import moment from "moment";
import { DateTypes } from "./configs";

export const formatLongWithDateType = (value, dateType = DateTypes.YEARLY) => {
  let format = "YY.MM.DD";
  if (dateType === DateTypes.YEARLY) {
    format = "YYYY";
  } else if (dateType === DateTypes.MONTHLY) {
    format = "YY.MM";
  }
  return moment(new Date(value)).format(format);
};

export const formatLong = (value, format) => {
  return moment(new Date(value)).format(format);
};

export const formatDate = (value, dateType = DateTypes.WEEKLY) => {
  if (dateType === DateTypes.YEARLY) {
    return formatLongToY(value);
  } else if (dateType === DateTypes.MONTHLY) {
    return formatLongToYm(value);
  } else {
    return formatLongToYmd(value);
  }
};

export const formatLongToY = (value) => {
  try {
    return moment(new Date(value)).format("YYYY");
  } catch (err) {
    console.log("error: %O, value:%O", err, value);
  }
};

export const formatLongToYm = (value) => {
  try {
    return moment(new Date(value)).format("YY.MM");
  } catch (err) {
    console.log("error: %O, value:%O", err, value);
  }
};

export const formatLongToYmd = (value) => {
  try {
    return moment(new Date(value)).format("YY.MM.DD");
  } catch (err) {
    console.log("error: %O, value:%O", err, value);
  }
};

export const formatLongToTime = (value) => {
  return moment(new Date(value)).format("YY.MM.DD HH:mm:ss");
};

export const longMinusMonthFromCurrent = (month) => {
  let current = new Date();
  current.setMonth(current.getMonth() - month);
  return current.getTime();
};

export const getPreviousWeeksDateInLong = (weeksAgo) => {
  const currentDate = new Date();
  const pastDate = new Date(currentDate.getTime() - getWeekInLong(weeksAgo));
  return pastDate.getTime(); // 날짜의 long value (Unix timestamp) 반환
};

export const ymdToLong = (ymd) => {
  const str = String(ymd);
  const year = parseInt(str.substring(0, 4), 10);
  const month = parseInt(str.substring(4, 6), 10) - 1; // JS에서는 0-based month
  const day = parseInt(str.substring(6, 8), 10);

  const date = new Date(year, month, day);
  return date.getTime(); // → timestamp (long)
};

export const ymToLong = (ym) => {
  const str = String(ym);
  const year = parseInt(str.substring(0, 4), 10); // 2025
  const month = parseInt(str.substring(4, 6), 10) - 1; // JS에서는 0-based month

  const date = new Date(year, month, 1);
  return date.getTime(); // → timestamp (long)
};

export const getCurrentYm = (plus = 0) => {
  const now = new Date();
  const year = now.getFullYear(); // 2025
  const month = now.getMonth() + 1 + plus; // 0-based -> 1-based
  return year * 100 + month; // 202501
};

export const generateYmDates = (startYm, endYm) => {
  const dates = [];
  let currentYm = startYm;

  while (currentYm <= endYm) {
    dates.push(ymToLong(currentYm));

    // 다음 달로 이동
    const year = Math.floor(currentYm / 100);
    const month = currentYm % 100;

    if (month === 12) {
      currentYm = (year + 1) * 100 + 1;
    } else {
      currentYm = year * 100 + (month + 1);
    }
  }

  return dates;
};

export const getYearInLong = (years) => {
  // 한 달은 31일, 하루는 24시간, 한 시간은 60분, 1분은 60초, 1초는 1000밀리초
  return years * 365 * 24 * 60 * 60 * 1000;
};

export const getMonthInLong = (months) => {
  // 한 달은 31일, 하루는 24시간, 한 시간은 60분, 1분은 60초, 1초는 1000밀리초
  return months * 29 * 24 * 60 * 60 * 1000;
};

export const getWeekInLong = (weeks) => {
  // 한 주는 7일, 하루는 24시간, 한 시간은 60분, 1분은 60초, 1초는 1000밀리초
  return weeks * 7 * 24 * 60 * 60 * 1000;
};

export const filterDates = (
  dates,
  from,
  to = undefined,
  dateType = DateTypes.WEEKLY,
  absolute = false,
) => {
  let lastDate = dates[dates.length - 1];
  if (to !== undefined) {
    lastDate = to;
  }
  let initFrom = from;
  // from이 undefined일 경우 모든 데이터를 가져오기 위해 가장 작은 값을 셋업한다.
  if (initFrom === undefined) {
    // absolute이든 아니든 date[0] 이면 둘다 만족한다.
    // abolute가 아니더라도, initfrom을 빼면 아주 작은 값이 되므로 상관없음
    initFrom = dates[0];
  }

  var fromDate = initFrom;
  if (!absolute) {
    fromDate = lastDate - initFrom;
  }
  let startIndex = 0;
  const result = [];
  for (const date of dates) {
    if (fromDate <= date && lastDate >= date) {
      result.push(date);
    } else {
      startIndex += 1;
    }
  }
  const filterDateRange = `(${formatDate(fromDate, dateType)}~${formatDate(
    lastDate,
    dateType,
  )})`;

  return {
    filtered: result,
    startIndex,
    filterDateRange,
  };
};

export const filterDatesFromIndex = (
  dates,
  from,
  to = undefined,
  excludeFrom = false,
) => {
  let lastIndex = dates.length - 1;
  if (to !== undefined) {
    lastIndex = to;
  }
  const startIndex = excludeFrom ? from + 1 : from;
  return dates.slice(startIndex, lastIndex + 1);
};

export const filterDataFromIndex = (
  indexs,
  from,
  to = undefined,
  excludeFrom = false,
) => {
  const result = [];
  for (var index of indexs) {
    let lastIndex = index.data.length - 1;
    if (to !== undefined) {
      lastIndex = to;
    }

    const startIndex = excludeFrom ? from + 1 : from;
    const data = index.data.slice(startIndex, lastIndex + 1);
    result.push({ ...index, data });
  }
  return result;
};
